export const SET_ALL_COMPANIES = 'SET_ALL_COMPANIES'
export const ADD_NEW_COMPANY = 'ADD_NEW_COMPANY'
export const DELETE_COMPANY = 'DELETE_COMPANY'
export const UPDATE_EXISTING_COMPANY = 'UPDATE_EXISTING_COMPANY'
